import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import SizeModel from '../../models/SizeModel';
import DataService from "../../services/data.service";
import Sizes_popup_AddSize from './Popups/Sizes_popup_AddSize';

const Sizes: React.FC = () => {
    const [data, setData] = useState<SizeModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<SizeModel[]>('api/v1/sizes')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/sizes/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { title: 'ID', key: true, dataProp: 'id', dataType: 'number' },
        { title: 'Name', dataProp: 'name', filterInfo: { filterType: 'Textbox' } },
        { title: 'Size set', dataProp: 'sizeSet.name', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Sort order', dataProp: 'sortOrder', dataType: 'number' },
        { title: 'Begin date', dataProp: 'beginDate', dataType: 'date' },
        { title: 'End date', dataProp: 'endDate', dataType: 'date' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.EditSize)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    return (
        <div className='main-content'>
            <Container fluid>
                <Row>
                    <Col md={12}>
                        <Card title='Sizes'
                            content={
                                <DataTable
                                    name='dtSizes'
                                    tableData={data}
                                    colInfos={colInfos}
                                    navigateTitle='Size'
                                    navigateUrl='/plm/itemsetup/size/'
                                />
                            }
                        />
                    </Col>
                </Row>
            </Container>
            {showPopup && (<Sizes_popup_AddSize show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />)}
        </div>
    );
}
export default Sizes;